import { createContext } from 'react';
import type { ChatEntryPoint } from '@/services/chat';

export interface OpenChatOptions {
  /** イベント画面から開いたときのイベント ID（ホームがそのイベント向けになる） */
  eventId?: string;
  /** どこから開いたか（計測用） */
  entry?: NonNullable<ChatEntryPoint>;
}

export interface ChatContextValue {
  isOpen: boolean;
  /** 開くたびに増える番号。パネルはこれが変わったらホームから表示し直す */
  openCount: number;
  /** ホームの文脈のイベント（イベント画面から開いたときだけ） */
  contextEventId: string | null;
  /** どこから開いたか */
  entry: NonNullable<ChatEntryPoint>;
  /** 最後の会話 ID（ホームの「前の会話の続き」に使う） */
  conversationId: string | null;
  openChat: (options?: OpenChatOptions) => void;
  closeChat: () => void;
  setConversationId: (conversationId: string | null) => void;
  /** ホームの文脈のイベントを外す（文脈チップの ×） */
  clearContext: () => void;
}

// Context object kept in a separate module to satisfy fast refresh
export const ChatContext = createContext<ChatContextValue | null>(null);
